import React, { useState, useRef, useEffect } from "react";
import { styled } from "../../stitches.config";

import Link from "../Link";
import KulkiSvg from "./KulkiSvg"

import PlayIcon from "../../assets/img/play.svg";
import Youtube from "../Article/Parts/Youtube";

import Media from "./Media";

const SpecialLG = props => {
    const { article, size = 'default', handleClick = () => { } } = props;
    const isDesktop = window.innerWidth > 992;
    const ref = useRef(null);

    return (
        <BoxWrapper onClick={handleClick} ref={ref} hasMobilePcs={props.article.hasMobilePcs} hasDesktopPcs={props.article.hasDesktopPcs} className={article.background ? 'background--' + article.background : null + " photo-on-top"}>
            <Link to={article.link}>
                <ImageWrapper>
                    <img src={article.img} />
                </ImageWrapper>
                <Description>
                    {article.description}
                </Description>
                <Title className="photo-on-top__title" size={props.size} hasMobilePcs={props.article.hasMobilePcs} hasDesktopPcs={props.article.hasDesktopPcs}>
                    {article.title}
                </Title>
            </Link>
        </BoxWrapper>
    );
};

const Title = styled("span", {
    fontSize: "16px",
    lineHeight: "18px",
    paddingLeft: "10px",
    paddingRight: "10px",
    display: "block",
    maxHeight: "94px",
    width: "100%",
    overflow: "hidden",
    color: "#000",
    zIndex: 10,
    marginTop: "4px",
    fontFamily: '"Montserrat", sans-serif'
});

const Description = styled("div", {
    color: "#000",
    marginLeft: "10px",
    marginTop: "5px",
    fontSize: "20px",
    fontFamily: '"Montserrat", sans-serif',
    fontWeight: "bold",
    lineHeight: "22px",
    transition: "0.3s"
});

const ImageWrapper = styled("div", {
    paddingTop: "1px",
    "img": {
        width: "249px",
        display: "block",
        height: "204px",
        zIndex: 1,
        margin: "2px auto 0 auto"
    }
});

const BoxWrapper = styled("div", {
    width: "256px",
    height: "338px",
    overflow: "visible",
    position: "relative",
    "> a": {
        borderRadius: "10px",
        transform: "translateZ(0)",
        backgroundColor: "#ffffff",
        textDecoration: "none",
        display: "block",
        transition: "0.3s",
        width: "100%",
        height: "100%",
        "&:hover": {
            position: "absolute",
            transform: "scale(1.03)",
            [`& ${Description}`]: {
                color: "$primary",
                transition: "0.3s"
            }
        }
    },
    "@media (min-width: 992px)": {
        "> a": {
            backgroundColor: "#ffffff"
        }
    },
    variants: {
        "hasMobilePcs": {
            true: {
                "> a": {
                    backgroundColor: "rgba(1, 1, 1, 0.2)"
                }
            },
            false: {}
        },
        "hasDesktopPcs": {
            true: {
                "@media (min-width: 992px)": {
                    "> a": {
                        backgroundColor: "rgba(1, 1, 1, 0.2)"
                    }
                }
            },
            false: {}
        }
    }
});

export default SpecialLG;
